module.exports = __webpack_public_path__ + "img/qr-appstore.ec0730dd.png";